import React, { useState } from 'react';
import { Stack, Typography, IconButton, Collapse } from '@mui/material';
import { ExpandMore, ExpandLess } from '@mui/icons-material';

function ItemImageThumbnails({ images, itemName, maxDisplay = 3, size = 60, disableClick = false }) {
    const [expanded, setExpanded] = useState(false);

    // TODO:: Don't truncate to only one
    images = images.slice(0, 1);

    if (!images || images.length === 0) {
        return null;
    }

    const handleToggle = () => {
        setExpanded(!expanded);
    };

    return (
        <Stack spacing={1}>
            <Stack 
                direction="row" 
                alignItems="center" 
                spacing={1}
                onClick={handleToggle}
                sx={{ cursor: 'pointer', userSelect: 'none' }}
            >
                <Typography variant="caption" color="text.secondary">
                    Item Images ({images.length})
                </Typography>
                <IconButton size="small" sx={{ p: 0 }}>
                    {expanded ? <ExpandLess fontSize="small" /> : <ExpandMore fontSize="small" />}
                </IconButton>
            </Stack>
            <Collapse in={expanded}>
                <Stack direction="row" spacing={1} sx={{ flexWrap: 'wrap' }}>
                    {images.slice(0, maxDisplay).map((image, index) => (
                        <img
                            key={image.id || index}
                            src={image.presigned_url || image.url || image.image_url}
                            alt={`${itemName} ${index + 1}`}
                            style={{
                                width: `${size}px`,
                                height: `${size}px`,
                                objectFit: 'contain',
                                borderRadius: '4px',
                                border: '1px solid #e0e0e0',
                                cursor: disableClick ? 'default' : 'pointer'
                            }}
                            {...(!disableClick && { onClick: () => {} })}
                        />
                    ))}
                    {images.length > maxDisplay && (
                        <Typography 
                            variant="caption" 
                            color="text.secondary" 
                            sx={{ alignSelf: 'center' }}
                        >
                            +{images.length - maxDisplay} more
                        </Typography>
                    )}
                </Stack>
            </Collapse>
        </Stack>
    );
}

export default ItemImageThumbnails;